module.exports = __webpack_public_path__ + "static/logo_malakoff_mederic_nb-abd4b82c9a0e7595cc8bca4a977e3021.svg";